<template>
  <svg
    :class="customClass"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_20174_158375"
      style="mask-type: alpha;"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <rect x="0.171875" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_20174_158375)">
      <path
        d="M5.67188 17.25C4.20821 17.25 2.96729 16.741 1.94912 15.723C0.930958 14.705 0.421875 13.4643 0.421875 12.0008C0.421875 10.5374 0.930958 9.2965 1.94912 8.278C2.96729 7.25933 4.20821 6.75 5.67188 6.75C6.25471 6.75 6.81388 6.8535 7.34938 7.0605C7.88488 7.26767 8.36804 7.56158 8.79887 7.94225L10.7104 9.627L9.57588 10.6307L7.79488 9.05775C7.50271 8.80642 7.17387 8.60892 6.80837 8.46525C6.44304 8.32175 6.06396 8.25 5.67112 8.25C4.63562 8.25 3.75188 8.61625 3.01988 9.34875C2.28787 10.0811 1.92188 10.9653 1.92188 12.0015C1.92188 13.0377 2.28787 13.9215 3.01988 14.653C3.75188 15.3843 4.63562 15.75 5.67112 15.75C6.06396 15.75 6.44304 15.6783 6.80837 15.5348C7.17387 15.3911 7.50271 15.1936 7.79488 14.9423L15.5449 7.94225C15.9694 7.55508 16.4504 7.25958 16.9879 7.05575C17.5255 6.85192 18.0869 6.75 18.6719 6.75C20.1355 6.75 21.3765 7.259 22.3946 8.277C23.4128 9.295 23.9219 10.5357 23.9219 11.9992C23.9219 13.4626 23.4128 14.7035 22.3946 15.722C21.3765 16.7407 20.1355 17.25 18.6719 17.25C18.0872 17.25 17.5292 17.1448 16.9979 16.9345C16.4664 16.7243 15.982 16.4321 15.5449 16.0577L13.6526 14.373L14.7679 13.3595L16.5489 14.9423C16.841 15.2013 17.1699 15.4007 17.5354 15.5405C17.9007 15.6802 18.2798 15.75 18.6726 15.75C19.7081 15.75 20.5919 15.3837 21.3239 14.6512C22.0559 13.9189 22.4219 13.0347 22.4219 11.9985C22.4219 10.9623 22.0559 10.0785 21.3239 9.347C20.5919 8.61567 19.7081 8.25 18.6726 8.25C18.2798 8.25 17.9007 8.32175 17.5354 8.46525C17.1699 8.60892 16.841 8.80642 16.5489 9.05775L8.79887 16.0577C8.37437 16.4449 7.89337 16.7404 7.35587 16.9443C6.81821 17.1481 6.25688 17.25 5.67188 17.25Z"
        fill="#1E264C"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "InfiniteIcon",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
  },
};
</script>
